var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orkStockGrid"},[_c('OrkStock',{attrs:{"show-stock-alert":false,"offer-id":_vm.defaultOfferId,"quantity":_vm.stockQuantity}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }